import { render, staticRenderFns } from "./ProfessionalInterventionInfoQuestion.vue?vue&type=template&id=4ff6e0ee"
import script from "./ProfessionalInterventionInfoQuestion.vue?vue&type=script&lang=ts"
export * from "./ProfessionalInterventionInfoQuestion.vue?vue&type=script&lang=ts"
import style0 from "./ProfessionalInterventionInfoQuestion.vue?vue&type=style&index=0&id=4ff6e0ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports